import type { MultilingualQuestion } from '../../types/multilingualQuestion';

// Multilingual version — road-markings
export const roadMarkingsMultilingual: MultilingualQuestion[] = [
  {
    id: 'q-rm-1',
    text: {
      en: 'What does a solid white line in the center of the road indicate?',
      nl: 'Wat geeft een doorgetrokken witte streep in het midden van de rijbaan aan?',
      ar: 'ماذا تدل الخط الأبيض المتصل في منتصف الطريق؟',
    },
    options: [
      {
        id: 'q-rm-1o1',
        text: {
          en: 'You can overtake if safe',
          nl: 'U mag inhalen als het veilig is',
          ar: 'يمكنك تجاوز المركبات إذا كان ذلك آمنا',
        },
      },
      {
        id: 'q-rm-1o2',
        text: {
          en: 'No overtaking allowed',
          nl: 'Inhalen is niet toegestaan',
          ar: 'التجاوز غير مسموح',
        },
      },
      {
        id: 'q-rm-1o3',
        text: {
          en: 'Overtaking allowed only for motorcycles',
          nl: 'Inhalen alleen voor motorfietsen toegestaan',
          ar: 'التجاوز مسموح للدراجات النارية فقط',
        },
      },
      {
        id: 'q-rm-1o4',
        text: {
          en: 'Overtaking allowed only during daylight',
          nl: 'Inhalen alleen overdag toegestaan',
          ar: 'التجاوز مسموح في النهار فقط',
        },
      },
    ],
    correctAnswerId: 'q-rm-1o2',
    explanation: {
      en: 'A solid white line in the center of the road indicates that overtaking is not allowed. You must stay in your lane.',
      nl: 'Een doorgetrokken witte streep in het midden van de rijbaan betekent dat inhalen niet is toegestaan. U moet in uw rijstrook blijven.',
      ar: 'الخط الأبيض المتصل في منتصف الطريق يعني أن التجاوز غير مسموح. يجب أن تبقى في مسارك.',
    },
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-1-solid-white-line.jpg',
    subject: 'Road Markings',
  },
  {
    id: 'q-rm-2',
    text: {
      en: 'What does a broken white line in the center of the road indicate?',
      nl: 'Wat geeft een onderbroken witte streep in het midden van de rijbaan aan?',
      ar: 'ماذا تدل الخط الأبيض المتقطع في منتصف الطريق؟',
    },
    options: [
      {
        id: 'q-rm-2o1',
        text: {
          en: 'No overtaking allowed',
          nl: 'Inhalen is niet toegestaan',
          ar: 'التجاوز غير مسموح',
        },
      },
      {
        id: 'q-rm-2o2',
        text: {
          en: 'Overtaking allowed if safe',
          nl: 'Inhalen toegestaan indien veilig',
          ar: 'التجاوز مسموح إذا كان آمنا',
        },
      },
      {
        id: 'q-rm-2o3',
        text: {
          en: 'Overtaking allowed only for emergency vehicles',
          nl: 'Inhalen alleen voor hulpdiensten toegestaan',
          ar: 'التجاوز مسموح لمركبات الطوارئ فقط',
        },
      },
      {
        id: 'q-rm-2o4',
        text: {
          en: 'Overtaking allowed only on the left',
          nl: 'Inhalen alleen links toegestaan',
          ar: 'التجاوز مسموح على اليسار فقط',
        },
      },
    ],
    correctAnswerId: 'q-rm-2o2',
    explanation: {
      en: 'A broken white line indicates that overtaking is allowed if it is safe to do so and there is sufficient visibility.',
      nl: 'Een onderbroken witte streep betekent dat inhalen is toegestaan als het veilig kan en er voldoende zicht is.',
      ar: 'الخط الأبيض المتقطع يعني أن التجاوز مسموح إذا كان آمنا وكانت الرؤية كافية.',
    },
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-2-broken-white-line.jpg',
    subject: 'Road Markings',
  },
  {
    id: 'q-rm-3',
    text: {
      en: 'What does a yellow line along the edge of the road indicate?',
      nl: 'Wat geeft een gele streep langs de rand van de weg aan?',
      ar: 'ماذا تدل الخط الأصفر على حافة الطريق؟',
    },
    options: [
      {
        id: 'q-rm-3o1',
        text: {
          en: 'No parking allowed',
          nl: 'Parkeren is niet toegestaan',
          ar: 'الوقوف غير مسموح',
        },
      },
      {
        id: 'q-rm-3o2',
        text: {
          en: 'Parking allowed for 30 minutes',
          nl: 'Parkeren maximaal 30 minuten toegestaan',
          ar: 'الوقوف مسموح لمدة 30 دقيقة',
        },
      },
      {
        id: 'q-rm-3o3',
        text: {
          en: 'Parking allowed for residents only',
          nl: 'Parkeren alleen voor bewoners toegestaan',
          ar: 'الوقوف مسموح للسكان فقط',
        },
      },
      {
        id: 'q-rm-3o4',
        text: {
          en: 'Parking allowed during certain hours',
          nl: 'Parkeren alleen op bepaalde tijden toegestaan',
          ar: 'الوقوف مسموح في أوقات محددة',
        },
      },
    ],
    correctAnswerId: 'q-rm-3o1',
    explanation: {
      en: 'A yellow line along the edge of the road indicates that parking is not allowed at any time.',
      nl: 'Een gele streep langs de rand van de weg betekent dat parkeren op geen enkel moment is toegestaan.',
      ar: 'الخط الأصفر على حافة الطريق يعني أن الوقوف غير مسموح في أي وقت.',
    },
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-3-yellow-edge-line.jpg',
    subject: 'Road Markings',
  },
  {
    id: 'q-rm-4',
    text: {
      en: 'What does a blue line along the edge of the road indicate?',
      nl: 'Wat geeft een blauwe streep langs de rand van de weg aan?',
      ar: 'ماذا تدل الخط الأزرق على حافة الطريق؟',
    },
    options: [
      {
        id: 'q-rm-4o1',
        text: {
          en: 'No parking allowed',
          nl: 'Parkeren is niet toegestaan',
          ar: 'الوقوف غير مسموح',
        },
      },
      {
        id: 'q-rm-4o2',
        text: {
          en: 'Parking for disabled persons only',
          nl: 'Parkeren alleen voor gehandicapten',
          ar: 'الوقوف لذوي الإعاقة فقط',
        },
      },
      {
        id: 'q-rm-4o3',
        text: {
          en: 'Parking for residents only',
          nl: 'Parkeren alleen voor bewoners toegestaan',
          ar: 'الوقوف للسكان فقط',
        },
      },
      {
        id: 'q-rm-4o4',
        text: {
          en: 'Parking with a permit only',
          nl: 'Parkeren alleen met vergunning',
          ar: 'الوقوف بتصريح فقط',
        },
      },
    ],
    correctAnswerId: 'q-rm-4o2',
    explanation: {
      en: 'A blue line indicates parking reserved for disabled persons. You must have a valid disabled parking permit to park here.',
      nl: 'Een blauwe streep geeft parkeerplaatsen voor gehandicapten aan. U moet een geldige gehandicaptenparkeervergunning hebben om hier te parkeren.',
      ar: 'الخط الأزرق يشير إلى موقف مخصص لذوي الإعاقة. يجب أن يكون لديك تصريح وقوف صالح لذوي الإعاقة.',
    },
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-4-blue-disabled-parking.jpg',
    subject: 'Road Markings',
  },
  {
    id: 'q-rm-5',
    text: {
      en: 'What does a zigzag line on the road indicate?',
      nl: 'Wat geven zigzagstrepen op de weg aan?',
      ar: 'ماذا تدل الخطوط المتعرجة على الطريق؟',
    },
    options: [
      {
        id: 'q-rm-5o1',
        text: {
          en: 'A pedestrian crossing',
          nl: 'Een voetgangersoversteekplaats',
          ar: 'معبر مشاة',
        },
      },
      {
        id: 'q-rm-5o2',
        text: {
          en: 'A bus stop',
          nl: 'Een bushalte',
          ar: 'موقف حافلة',
        },
      },
      {
        id: 'q-rm-5o3',
        text: {
          en: 'A school zone',
          nl: 'Een schoolzone',
          ar: 'منطقة مدرسة',
        },
      },
      {
        id: 'q-rm-5o4',
        text: {
          en: 'A construction zone',
          nl: 'Een werkzone',
          ar: 'منطقة أشغال',
        },
      },
    ],
    correctAnswerId: 'q-rm-5o1',
    explanation: {
      en: 'Zigzag lines indicate a pedestrian crossing. You must not park or overtake in this area.',
      nl: 'Zigzagstrepen duiden op een voetgangersoversteekplaats. U mag hier niet parkeren of inhalen.',
      ar: 'الخطوط المتعرجة تشير إلى معبر مشاة. لا يجوز الوقوف أو التجاوز في هذه المنطقة.',
    },
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-5-zigzag-pedestrian.jpg',
    subject: 'Road Markings',
  },
  {
    id: 'q-rm-6',
    text: {
      en: 'What does a white arrow pointing straight ahead on the road indicate?',
      nl: 'Wat geeft een witte pijl rechtdoor op de weg aan?',
      ar: 'ماذا تدل السهم الأبيض المستقيم على الطريق؟',
    },
    options: [
      {
        id: 'q-rm-6o1',
        text: {
          en: 'You must turn left',
          nl: 'U moet linksaf',
          ar: 'يجب أن تنعطف يسارا',
        },
      },
      {
        id: 'q-rm-6o2',
        text: {
          en: 'You must turn right',
          nl: 'U moet rechtsaf',
          ar: 'يجب أن تنعطف يمينا',
        },
      },
      {
        id: 'q-rm-6o3',
        text: {
          en: 'You must go straight ahead',
          nl: 'U moet rechtdoor',
          ar: 'يجب أن تسير مستقيما',
        },
      },
      {
        id: 'q-rm-6o4',
        text: {
          en: 'You can choose any direction',
          nl: 'U mag elke richting kiezen',
          ar: 'يمكنك اختيار أي اتجاه',
        },
      },
    ],
    correctAnswerId: 'q-rm-6o3',
    explanation: {
      en: 'A white arrow pointing straight ahead indicates that you must proceed in that direction.',
      nl: 'Een witte pijl rechtdoor betekent dat u die richting moet volgen.',
      ar: 'السهم الأبيض إلى الأمام يعني أنه يجب عليك المضي في ذلك الاتجاه.',
    },
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-6-arrow-straight.jpg',
    subject: 'Road Markings',
  },
  {
    id: 'q-rm-7',
    text: {
      en: 'What does a white bicycle symbol on the road indicate?',
      nl: 'Wat geeft een wit fietspictogram op de weg aan?',
      ar: 'ماذا تدل رمز الدراجة الأبيض على الطريق؟',
    },
    options: [
      {
        id: 'q-rm-7o1',
        text: {
          en: 'A bicycle lane',
          nl: 'Een fietsstrook',
          ar: 'مسار دراجات',
        },
      },
      {
        id: 'q-rm-7o2',
        text: {
          en: 'A bicycle crossing',
          nl: 'Een fietsoversteekplaats',
          ar: 'معبر دراجات',
        },
      },
      {
        id: 'q-rm-7o3',
        text: {
          en: 'A bicycle parking area',
          nl: 'Een fietsenstalling',
          ar: 'منطقة وقوف دراجات',
        },
      },
      {
        id: 'q-rm-7o4',
        text: {
          en: 'A bicycle repair shop',
          nl: 'Een fietsenmaker',
          ar: 'ورشة إصلاح دراجات',
        },
      },
    ],
    correctAnswerId: 'q-rm-7o1',
    explanation: {
      en: 'A white bicycle symbol indicates a bicycle lane. Motor vehicles should not drive in this lane.',
      nl: 'Een wit fietspictogram duidt een fietsstrook aan. Motorvoertuigen mogen hier niet rijden.',
      ar: 'رمز الدراجة الأبيض يشير إلى مسار دراجات. لا ينبغي لمركبات الآلية السير في هذا المسار.',
    },
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-7-bicycle-symbol.jpg',
    subject: 'Road Markings',
  },
  {
    id: 'q-rm-8',
    text: {
      en: 'What does a white "STOP" word painted on the road indicate?',
      nl: 'Wat geeft het woord STOP in het wit op de weg aan?',
      ar: 'ماذا تدل كلمة «توقف» (STOP) المرسومة بالأبيض على الطريق؟',
    },
    options: [
      {
        id: 'q-rm-8o1',
        text: {
          en: 'You must slow down',
          nl: 'U moet vertragen',
          ar: 'يجب أن تبطئ',
        },
      },
      {
        id: 'q-rm-8o2',
        text: {
          en: 'You must stop completely',
          nl: 'U moet volledig tot stilstand komen',
          ar: 'يجب أن تتوقف تماما',
        },
      },
      {
        id: 'q-rm-8o3',
        text: {
          en: 'You must yield to pedestrians',
          nl: 'U moet voorrang verlenen aan voetgangers',
          ar: 'يجب أن تمنح الأولوية للمشاة',
        },
      },
      {
        id: 'q-rm-8o4',
        text: {
          en: 'You must honk your horn',
          nl: 'U moet claxonneren',
          ar: 'يجب أن تستخدم البوق',
        },
      },
    ],
    correctAnswerId: 'q-rm-8o2',
    explanation: {
      en: 'A white "STOP" word painted on the road reinforces the requirement to stop completely at the stop line or before entering the intersection.',
      nl: 'Het woord STOP op de weg onderstreept dat u volledig moet stoppen bij de stopstreep of vóór het invoegen op de kruising.',
      ar: 'كلمة STOP على الطريق تؤكد وجوب التوقف التام عند خط التوقف أو قبل دخول التقاطع.',
    },
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-8-stop-text.jpg',
    subject: 'Road Markings',
  },
  {
    id: 'q-rm-9',
    text: {
      en: 'What does a white diamond symbol on the road indicate?',
      nl: 'Wat geeft een wit ruitvormig symbool op de weg aan?',
      ar: 'ماذا تدل علامة الماسة البيضاء على الطريق؟',
    },
    options: [
      {
        id: 'q-rm-9o1',
        text: {
          en: 'A priority road',
          nl: 'Een voorrangsweg',
          ar: 'طريق ذو أولوية',
        },
      },
      {
        id: 'q-rm-9o2',
        text: {
          en: 'A school zone',
          nl: 'Een schoolzone',
          ar: 'منطقة مدرسة',
        },
      },
      {
        id: 'q-rm-9o3',
        text: {
          en: 'A construction zone',
          nl: 'Een werkzone',
          ar: 'منطقة أشغال',
        },
      },
      {
        id: 'q-rm-9o4',
        text: {
          en: 'A parking zone',
          nl: 'Een parkeerzone',
          ar: 'منطقة وقوف',
        },
      },
    ],
    correctAnswerId: 'q-rm-9o1',
    explanation: {
      en: 'A white diamond symbol indicates a priority road. Traffic on this road has the right of way over traffic entering from side roads.',
      nl: 'Een wit ruitvormig symbool duidt een voorrangsweg aan. Verkeer op deze weg heeft voorrang op verkeer van zijwegen.',
      ar: 'رمز الماسة الأبيض يشير إلى طريق له أولوية. لمرور هذا الطريق أولوية على المرور القادم من الطرق الفرعية.',
    },
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-9-diamond-priority.jpg',
    subject: 'Road Markings',
  },
  {
    id: 'q-rm-10',
    text: {
      en: 'What does a white "GIVE WAY" text painted on the road indicate?',
      nl: 'Wat geeft de tekst VOORRANG VERLENEN (GIVE WAY) in het wit op de weg aan?',
      ar: 'ماذا تدل عبارة «أعط الطريق» (GIVE WAY) المرسومة بالأبيض على الطريق؟',
    },
    options: [
      {
        id: 'q-rm-10o1',
        text: {
          en: 'You must stop completely',
          nl: 'U moet volledig tot stilstand komen',
          ar: 'يجب أن تتوقف تماما',
        },
      },
      {
        id: 'q-rm-10o2',
        text: {
          en: 'You must yield to other traffic',
          nl: 'U moet voorrang verlenen aan ander verkeer',
          ar: 'يجب أن تمنح الأولوية لبقية المرور',
        },
      },
      {
        id: 'q-rm-10o3',
        text: {
          en: 'You must honk your horn',
          nl: 'U moet claxonneren',
          ar: 'يجب أن تستخدم البوق',
        },
      },
      {
        id: 'q-rm-10o4',
        text: {
          en: 'You must slow down only',
          nl: 'U hoeft alleen te vertragen',
          ar: 'يكفي أن تبطئ فقط',
        },
      },
    ],
    correctAnswerId: 'q-rm-10o2',
    explanation: {
      en: 'A white "GIVE WAY" text reinforces the requirement to yield to other traffic before proceeding.',
      nl: 'De tekst VOORRANG VERLENEN onderstreept dat u ander verkeer voorrang moet verlenen voordat u verder rijdt.',
      ar: 'عبارة GIVE WAY على الطريق تؤكد وجوب منح الأولوية لبقية المرور قبل المضي.',
    },
    subject: 'Road Markings',
  },
  {
    id: 'q-rm-11',
    text: {
      en: 'What does a white "BUS" text painted on the road indicate?',
      nl: 'Wat geeft de tekst BUS in het wit op de weg aan?',
      ar: 'ماذا تدل كلمة BUS المرسومة بالأبيض على الطريق؟',
    },
    options: [
      {
        id: 'q-rm-11o1',
        text: {
          en: 'A bus lane',
          nl: 'Een busstrook',
          ar: 'مسار حافلات',
        },
      },
      {
        id: 'q-rm-11o2',
        text: {
          en: 'A bus stop',
          nl: 'Een bushalte',
          ar: 'موقف حافلة',
        },
      },
      {
        id: 'q-rm-11o3',
        text: {
          en: 'A bus parking area',
          nl: 'Een busparkeerplaats',
          ar: 'منطقة وقوف حافلات',
        },
      },
      {
        id: 'q-rm-11o4',
        text: {
          en: 'A bus terminal',
          nl: 'Een busstation',
          ar: 'محطة حافلات',
        },
      },
    ],
    correctAnswerId: 'q-rm-11o1',
    explanation: {
      en: 'A white "BUS" text indicates a bus lane. Only buses and authorized vehicles may use this lane.',
      nl: 'De tekst BUS duidt een busstrook aan. Alleen bussen en geautoriseerde voertuigen mogen deze strook gebruiken.',
      ar: 'كلمة BUS تشير إلى مسار حافلات. لا يجوز استخدامه إلا للحافلات والمركبات المصرح لها.',
    },
    subject: 'Road Markings',
  },
  {
    id: 'q-rm-12',
    text: {
      en: 'What does a white "TAXI" text painted on the road indicate?',
      nl: 'Wat geeft de tekst TAXI in het wit op de weg aan?',
      ar: 'ماذا تدل كلمة TAXI المرسومة بالأبيض على الطريق؟',
    },
    options: [
      {
        id: 'q-rm-12o1',
        text: {
          en: 'A taxi lane',
          nl: 'Een taxistrook',
          ar: 'مسار سيارات أجرة',
        },
      },
      {
        id: 'q-rm-12o2',
        text: {
          en: 'A taxi stand',
          nl: 'Een taxistandplaats',
          ar: 'موقف سيارات أجرة',
        },
      },
      {
        id: 'q-rm-12o3',
        text: {
          en: 'A taxi parking area',
          nl: 'Een taxiparkeerplaats',
          ar: 'منطقة وقوف سيارات أجرة',
        },
      },
      {
        id: 'q-rm-12o4',
        text: {
          en: 'A taxi office',
          nl: 'Een taxikantoor',
          ar: 'مكتب سيارات أجرة',
        },
      },
    ],
    correctAnswerId: 'q-rm-12o1',
    explanation: {
      en: 'A white "TAXI" text indicates a taxi lane. Only taxis and authorized vehicles may use this lane.',
      nl: 'De tekst TAXI duidt een taxistrook aan. Alleen taxi\'s en geautoriseerde voertuigen mogen deze strook gebruiken.',
      ar: 'كلمة TAXI تشير إلى مسار سيارات أجرة. لا يجوز استخدامه إلا لسيارات الأجرة والمركبات المصرح لها.',
    },
    subject: 'Road Markings',
  },
  {
    id: 'q-rm-13',
    text: {
      en: 'What does a double solid white line in the center of the road indicate?',
      nl: 'Wat geven twee doorgetrokken witte strepen in het midden van de rijbaan aan?',
      ar: 'ماذا تدل خطان أبيضان متصلان في منتصف الطريق؟',
    },
    options: [
      {
        id: 'q-rm-13o1',
        text: {
          en: 'Overtaking allowed if safe',
          nl: 'Inhalen toegestaan indien veilig',
          ar: 'التجاوز مسموح إذا كان آمنا',
        },
      },
      {
        id: 'q-rm-13o2',
        text: {
          en: 'No overtaking in either direction',
          nl: 'Geen inhalen in beide richtingen',
          ar: 'لا تجاوز في أي من الاتجاهين',
        },
      },
      {
        id: 'q-rm-13o3',
        text: {
          en: 'Overtaking allowed only on the left',
          nl: 'Inhalen alleen links toegestaan',
          ar: 'التجاوز مسموح على اليسار فقط',
        },
      },
      {
        id: 'q-rm-13o4',
        text: {
          en: 'Overtaking allowed at night only',
          nl: 'Inhalen alleen \'s nachts toegestaan',
          ar: 'التجاوز مسموح ليلا فقط',
        },
      },
    ],
    correctAnswerId: 'q-rm-13o2',
    explanation: {
      en: 'A double solid white line means you must not cross it to overtake. No overtaking in either direction.',
      nl: 'Dubbele doorgetrokken witte strepen betekenen dat u deze niet mag overschrijden om in te halen. Geen inhalen in beide richtingen.',
      ar: 'الخطان الأبيضان المتصلان يعنيان أنه لا يجوز عبورهما للتجاوز. لا تجاوز في أي اتجاه.',
    },
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-13-double-solid-line.jpg',
    subject: 'Road Markings',
  },
  {
    id: 'q-rm-14',
    text: {
      en: 'What does a yellow box with criss-cross markings on the road indicate?',
      nl: 'Wat geeft een geel vak met kruislings arcering op de weg aan?',
      ar: 'ماذا يعني مربع أصفر بخطوط متقاطعة على الطريق؟',
    },
    options: [
      {
        id: 'q-rm-14o1',
        text: {
          en: 'You may wait here in traffic',
          nl: 'U mag hier in de file wachten',
          ar: 'يمكنك الانتظار هنا في الزحام',
        },
      },
      {
        id: 'q-rm-14o2',
        text: {
          en: 'You must not enter unless your exit is clear',
          nl: 'U mag het vak niet inrijden tenzij uw uitrit vrij is',
          ar: 'لا تدخل إلا إذا كان مخرجك خاليا',
        },
      },
      {
        id: 'q-rm-14o3',
        text: {
          en: 'Parking allowed for 5 minutes',
          nl: 'Parkeren maximaal 5 minuten toegestaan',
          ar: 'الوقوف مسموح لمدة 5 دقائق',
        },
      },
      {
        id: 'q-rm-14o4',
        text: {
          en: 'Loading zone',
          nl: 'Een laad- en loszone',
          ar: 'منطقة تحميل وتفريغ',
        },
      },
    ],
    correctAnswerId: 'q-rm-14o2',
    explanation: {
      en: 'A yellow box (box junction) means you must not enter it unless your exit road or lane is clear. You may only enter to turn right if you are not blocking other traffic.',
      nl: 'Een geel kruislings gearceerd vak (kruispuntvak) betekent dat u het niet mag inrijden tenzij uw uitweg of -strook vrij is. Alleen rechtsaf mag u invoegen als u ander verkeer niet blokkeert.',
      ar: 'المربع الأصفر (منطقة تقاطع معلمة) يعني ألا تدخلها إلا إذا كان طريق أو مسار خروجك خاليا. يجوز الدخول للانعطاف يمينا فقط إذا لم تعيق بقية المرور.',
    },
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-14-yellow-box-junction.jpg',
    subject: 'Road Markings',
  },
  {
    id: 'q-rm-15',
    text: {
      en: 'What does a broken yellow line along the edge of the road indicate?',
      nl: 'Wat geeft een onderbroken gele streep langs de rand van de weg aan?',
      ar: 'ماذا تدل الخط الأصفر المتقطع على حافة الطريق؟',
    },
    options: [
      {
        id: 'q-rm-15o1',
        text: {
          en: 'No parking at any time',
          nl: 'Geen parkeren op elk moment',
          ar: 'لا وقوف في أي وقت',
        },
      },
      {
        id: 'q-rm-15o2',
        text: {
          en: 'No stopping; parking may be restricted to certain times',
          nl: 'Geen stilstaan; parkeren kan beperkt zijn tot bepaalde tijden',
          ar: 'منع التوقف؛ قد يقيد الوقوف بأوقات معينة',
        },
      },
      {
        id: 'q-rm-15o3',
        text: {
          en: 'Parking for residents only',
          nl: 'Parkeren alleen voor bewoners',
          ar: 'الوقوف للسكان فقط',
        },
      },
      {
        id: 'q-rm-15o4',
        text: {
          en: 'Parking allowed for 30 minutes',
          nl: 'Parkeren maximaal 30 minuten toegestaan',
          ar: 'الوقوف مسموح لمدة 30 دقيقة',
        },
      },
    ],
    correctAnswerId: 'q-rm-15o2',
    explanation: {
      en: 'A broken (dashed) yellow line often indicates no stopping or restricted parking. Check local signs for exact rules.',
      nl: 'Een onderbroken gele streep duidt vaak op een stilstandverbod of beperkt parkeren. Controleer lokale borden voor de exacte regels.',
      ar: 'الخط الأصفر المتقطع غالبا يعني منع التوقف أو وقوفا مقيدا. راجع اللافتات المحلية للقواعد الدقيقة.',
    },
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-15-broken-yellow-line.jpg',
    subject: 'Road Markings',
  },
  {
    id: 'q-rm-16',
    text: {
      en: 'What does a white triangle painted on the road at a junction usually indicate?',
      nl: 'Wat geeft een witte driehoek op de weg bij een kruising gewoonlijk aan?',
      ar: 'ماذا تدل المثلث الأبيض المرسوم على الطريق عند تقاطع عادة؟',
    },
    options: [
      {
        id: 'q-rm-16o1',
        text: {
          en: 'You have priority',
          nl: 'U heeft voorrang',
          ar: 'لك الأولوية',
        },
      },
      {
        id: 'q-rm-16o2',
        text: {
          en: 'Give way to traffic on the main road',
          nl: 'Voorrang verlenen aan verkeer op de voorrangsweg',
          ar: 'أعط الأولوية لمرور الطريق الرئيسي',
        },
      },
      {
        id: 'q-rm-16o3',
        text: {
          en: 'Speed bump ahead',
          nl: 'Een drempel voor u',
          ar: 'مطب أمامك',
        },
      },
      {
        id: 'q-rm-16o4',
        text: {
          en: 'Pedestrian crossing ahead',
          nl: 'Een voetgangersoversteekplaats voor u',
          ar: 'معبر مشاة أمامك',
        },
      },
    ],
    correctAnswerId: 'q-rm-16o2',
    explanation: {
      en: 'A white triangle (often with a give way sign) indicates you must give way to traffic on the main road.',
      nl: 'Een witte driehoek (vaak met een voorrang verlenen-bord) betekent dat u voorrang moet verlenen aan verkeer op de hoofdweg.',
      ar: 'المثلث الأبيض (غالبا مع إشارة أعط الطريق) يعني أنه يجب منح الأولوية لمرور الطريق الرئيسي.',
    },
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-16-white-triangle.jpg',
    subject: 'Road Markings',
  },
  {
    id: 'q-rm-17',
    text: {
      en: 'What do white diagonal stripes in a lane indicate?',
      nl: 'Wat geven witte diagonale strepen in een rijstrook aan?',
      ar: 'ماذا تدل الخطوط البيضاء المائلة في المسار؟',
    },
    options: [
      {
        id: 'q-rm-17o1',
        text: {
          en: 'Overtaking allowed',
          nl: 'Inhalen toegestaan',
          ar: 'التجاوز مسموح',
        },
      },
      {
        id: 'q-rm-17o2',
        text: {
          en: 'You must not drive on them; they separate traffic or protect a turn',
          nl: 'U mag er niet overheen rijden; ze scheiden verkeer of beschermen een bocht',
          ar: 'لا تسير عليها؛ تفصل المرور أو تحمي منعطفا',
        },
      },
      {
        id: 'q-rm-17o3',
        text: {
          en: 'Parking allowed',
          nl: 'Parkeren toegestaan',
          ar: 'الوقوف مسموح',
        },
      },
      {
        id: 'q-rm-17o4',
        text: {
          en: 'Cycle lane',
          nl: 'Een fietsstrook',
          ar: 'مسار دراجات',
        },
      },
    ],
    correctAnswerId: 'q-rm-17o2',
    explanation: {
      en: 'White diagonal stripes (hatched area) mark a zone you must not enter unless necessary. They separate traffic flows or protect a turning area.',
      nl: 'Witte diagonale strepen (schuin gearceerd gebied) markeren een zone die u niet mag betreden tenzij nodig. Ze scheiden verkeersstromen of beschermen een uitbuiging.',
      ar: 'الخطوط البيضاء المائلة (منطقة مظللة) تحدد منطقة لا تدخلها إلا عند الضرورة. تفصل تيارات المرور أو تحمي مساحة الانعطاف.',
    },
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-17-diagonal-stripes.jpg',
    subject: 'Road Markings',
  },
  {
    id: 'q-rm-18',
    text: {
      en: 'What does a white "30" in a circle on the road indicate?',
      nl: 'Wat geeft een wit cijfer 30 in een cirkel op de weg aan?',
      ar: 'ماذا تدل الرقم 30 داخل دائرة بيضاء على الطريق؟',
    },
    options: [
      {
        id: 'q-rm-18o1',
        text: {
          en: '30 km/h speed limit',
          nl: 'Maximumsnelheid 30 km/u',
          ar: 'حد سرعة 30 كم/س',
        },
      },
      {
        id: 'q-rm-18o2',
        text: {
          en: 'Zone 30 starts here',
          nl: 'Hier begint zone 30',
          ar: 'تبدأ هنا منطقة 30',
        },
      },
      {
        id: 'q-rm-18o3',
        text: {
          en: 'Parking for 30 minutes',
          nl: 'Parkeren maximaal 30 minuten',
          ar: 'وقوف لمدة 30 دقيقة',
        },
      },
      {
        id: 'q-rm-18o4',
        text: {
          en: 'Distance 30 m to junction',
          nl: 'Afstand 30 m tot de kruising',
          ar: 'مسافة 30 مترا إلى التقاطع',
        },
      },
    ],
    correctAnswerId: 'q-rm-18o1',
    explanation: {
      en: 'A speed limit painted on the road (e.g. 30 in a circle) indicates the maximum speed limit for that road.',
      nl: 'Een op de weg geschilderde snelheidslimiet (bijv. 30 in een cirkel) geeft de maximumsnelheid op die weg aan.',
      ar: 'حد السرعة المرسوم على الطريق (مثل 30 داخل دائرة) يبين السرعة القصوى على ذلك الطريق.',
    },
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-18-speed-limit-30.jpg',
    subject: 'Road Markings',
  },
  {
    id: 'q-rm-19',
    text: {
      en: 'What does a solid white line across your lane at a junction indicate?',
      nl: 'Wat geeft een doorgetrokken witte streep dwars over uw rijstrook bij een kruising aan?',
      ar: 'ماذا تدل خط أبيض متصل عبر مسارك عند تقاطع؟',
    },
    options: [
      {
        id: 'q-rm-19o1',
        text: {
          en: 'Recommended stopping point',
          nl: 'Aanbevolen stopplaats',
          ar: 'نقطة توقف موصى بها',
        },
      },
      {
        id: 'q-rm-19o2',
        text: {
          en: 'Stop line; you must stop before it if required',
          nl: 'Stopstreep; u moet ervoor stoppen indien vereist',
          ar: 'خط توقف؛ يجب أن تتوقف قبله عند الاقتضاء',
        },
      },
      {
        id: 'q-rm-19o3',
        text: {
          en: 'Cycle crossing',
          nl: 'Een fietsoversteekplaats',
          ar: 'معبر دراجات',
        },
      },
      {
        id: 'q-rm-19o4',
        text: {
          en: 'Parking boundary',
          nl: 'Grens van een parkeervak',
          ar: 'حد موقف',
        },
      },
    ],
    correctAnswerId: 'q-rm-19o2',
    explanation: {
      en: 'A solid white line across the lane is a stop line. You must stop before it when required (e.g. at a red light or stop sign).',
      nl: 'Een doorgetrokken witte streep dwars over de rijstrook is een stopstreep. U moet ervoor stoppen wanneer dat vereist is (bijv. bij rood licht of een stopbord).',
      ar: 'الخط الأبيض المتصل عبر المسار هو خط توقف. يجب التوقف قبله عند الاقتضاء (مثل الضوء الأحمر أو إشارة قف).',
    },
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-19-stop-line.jpg',
    subject: 'Road Markings',
  },
  {
    id: 'q-rm-20',
    text: {
      en: 'What does a white "P" with a line through it on the road indicate?',
      nl: 'Wat geeft een witte P met een streep erdoor op de weg aan?',
      ar: 'ماذا تدل حرف P أبيض مشطوب على الطريق؟',
    },
    options: [
      {
        id: 'q-rm-20o1',
        text: {
          en: 'Parking allowed',
          nl: 'Parkeren toegestaan',
          ar: 'الوقوف مسموح',
        },
      },
      {
        id: 'q-rm-20o2',
        text: {
          en: 'No parking',
          nl: 'Parkeren verboden',
          ar: 'ممنوع الوقوف',
        },
      },
      {
        id: 'q-rm-20o3',
        text: {
          en: 'Parking for permit holders only',
          nl: 'Parkeren alleen voor houders van een vergunning',
          ar: 'الوقوف لحاملي تصريح فقط',
        },
      },
      {
        id: 'q-rm-20o4',
        text: {
          en: 'Paid parking',
          nl: 'Betaald parkeren',
          ar: 'وقوف مدفوع',
        },
      },
    ],
    correctAnswerId: 'q-rm-20o2',
    explanation: {
      en: 'A "P" with a line through it or a similar marking indicates no parking. Do not park in that area.',
      nl: 'Een P met een streep erdoor of een vergelijkbare markering betekent parkeerverbod. Parkeer niet in dat gebied.',
      ar: 'حرف P مشطوب أو علامة مماثلة تعني منع الوقوف. لا توقف في تلك المنطقة.',
    },
    subject: 'Road Markings',
  },
];
